// extracted by mini-css-extract-plugin
export default {"share-button":"cxRPmf","shareButton":"cxRPmf","open":"Rjbwsy","share-icon":"bIf2Dz","shareIcon":"bIf2Dz"};